import React, { useEffect, useState } from 'react';
import '../css/Gifts.css';
import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';


const stripePromise = loadStripe('pk_live_51RaLovG1ayf6yxIseClJKLKIICISLsy7qsI0HRb6CICjVQxgf2SHBJUbz41qn6GXAhS3YXeOphh6KQZ3jbBorWJs009zrBj6g8'); // ✅ ta clé test publique Stripe

function Gifts() {
    const [gifts, setGifts] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const { t } = useTranslation();


    useEffect(() => {
        const fetchGifts = async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/gifts`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`
                    }
                });
                const data = await res.json();
                setGifts(data);
            } catch (err) {
                alert(t("gifts.selectRecipient"));

            }
        };
        fetchGifts();
    }, [t]);

    const handleSendGift = async (gift) => {
        if (isSending) return;
        setIsSending(true);
        const receiverId = localStorage.getItem("selectedUserId");
        const token = localStorage.getItem("authToken");

        if (!receiverId || !token) {
            alert(t("gifts.paymentError"));

            return;
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payment/create-checkout-session`, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    giftId: gift.id,
                    giftName: gift.name,
                    amount: gift.price,
                    receiverId: receiverId
                })
            });

            if (!res.ok) throw new Error("Échec du paiement");
            const data = await res.json();

            if (data.id) {
                const stripe = await stripePromise;
                await stripe.redirectToCheckout({ sessionId: data.id });
            }
        } catch (error) {
            console.error("Erreur Stripe :", error);
            alert("Une erreur s'est produite lors de l'envoi du cadeau.");
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="gifts-page">
            <h2>{t("gifts.title")}</h2>
            <p>{t("gifts.subtitle")}</p>

            <div className="gift-grid">
                {gifts.map((gift) => (
                    <div className="gift-card" key={gift.id}>
                        <img src={`../gifts/${gift.imageUrl}`} alt={gift.name} /> {/* 💡 adapte le chemin si tu sers des images statiques */}
                        <h4>{gift.name}</h4>
                        <p>{gift.description}</p>
                        <span className="gift-price">{gift.price / 100} $</span>
                        <button onClick={() => handleSendGift(gift)} disabled={isSending}>
                            {isSending ? t("gifts.sending") : t("gifts.sendGift")}
                        </button>                   
                         </div>
                ))}
            </div>
        </div>
    );
}

export default Gifts;
